import React from 'react';
import GenericTopBar from '../GenericTopBar';
import MainLogo from '../../../components/MainLogo';
import { useLocation, useNavigate } from 'react-router-dom';
import './MainTopBar.css';
import { FaUser } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';
import avatarIcon from '../../../../images/avatar-icon.png';
import arrowDown from '../../../../images/arrow-down.svg';

interface Props {
  isSticky: boolean;
  isLoggedIn: boolean;
  showAdminButton: boolean;
  additionalLeftChildren?: React.ReactNode;
  additionalMiddleChildren?: React.ReactNode;
  additionalRightChildren?: React.ReactNode;
  beforeUserChildren?: React.ReactNode; // Elements to show before user menu (like settings)
  // User props
  userName?: string;
}

const MainTopBar: React.FC<Props> = ({
  isSticky,
  isLoggedIn,
  showAdminButton,
  additionalLeftChildren,
  additionalMiddleChildren,
  additionalRightChildren,
  beforeUserChildren,
  userName = 'User',
}) => {
  const nav = useNavigate();
  const location = useLocation();
  const chatPagePath = '/chat';
  const aboutUsPagePath = '/aboutus';
  const adminPagePath = '/admin';

  return (
    <GenericTopBar
      sticky={isSticky}
      leftChildren={
        <div className="MainTopBarLogoRow">
          {additionalLeftChildren}
          <MainLogo nav={nav} />
        </div>
      }
      middleChildren={
        <>
          {additionalMiddleChildren}
          <ul className="MainTopBarList">
            <li>
              <NavLink
                to={chatPagePath}
                className={({ isActive }) =>
                  `MainTopBarLink ${isActive ? 'MainTopBarHighlightLink' : ''}`
                }
              >
                Chat
              </NavLink>
            </li>
            <li>
              <NavLink
                to={aboutUsPagePath}
                className={({ isActive }) =>
                  `MainTopBarLink ${isActive ? 'MainTopBarHighlightLink' : ''}`
                }
              >
                About Us
              </NavLink>
            </li>
            {showAdminButton && (
              <li>
                <NavLink
                  to={adminPagePath}
                  className={({ isActive }) =>
                    `MainTopBarLink ${isActive ? 'MainTopBarHighlightLink' : ''}`
                  }
                >
                  Admin
                </NavLink>
              </li>
            )}
          </ul>
        </>
      }
      rightChildren={
        <div className="MainTopBarUserButtonRow">
          {beforeUserChildren}

          {isLoggedIn && (
            <div className="MainTopBarUser-Element">
              <div className="MainTopBarUser-UserName">
                <h2>
                  {userName}
                </h2>
                <span
                  onClick={() => {
                    localStorage.removeItem('token'); // Remove token
                    nav('/'); // Navigate home
                    window.location.reload(); // Reload page
                  }}
                >
                  Sign Out
                </span>
              </div>
              <div className="MainTopBarUser-UserImage">
                <img src={avatarIcon} alt="Avatar Icon" />
              </div>
            </div>
          )}

          {additionalRightChildren}
          {isLoggedIn ? (
            <></>
          ) : (
            <>
              <button
                className="MainTopBarLoginButton"
                onClick={() => {
                  nav('/signin');
                }}
              >
                <FaUser />
                Sign In
              </button>
              <button
                className="MainTopBarSignUpButton"
                onClick={() => {
                  nav('/signup');
                }}
              >
                Sign Up
              </button>
            </>
          )}
        </div>
      }
    />
  );
};

export default MainTopBar;
